import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
export var DataList = function DataList() {
    _classCallCheck(this, DataList);
};
export var DataStepTransform = function DataStepTransform() {
    _classCallCheck(this, DataStepTransform);
};
export var DataStep = function DataStep() {
    _classCallCheck(this, DataStep);
};
export var DataTime = function DataTime() {
    _classCallCheck(this, DataTime);
};
export var DataDate = function DataDate() {
    _classCallCheck(this, DataDate);
};
export var ValueRange = function ValueRange() {
    _classCallCheck(this, ValueRange);
};
export var Attribute = function Attribute() {
    _classCallCheck(this, Attribute);

    this.name = '';
    this.value = '';
    this.code = [];
    this.desc = '';
    this.defaultValue = '';
    this.readable = false;
    this.writable = false;
    this.invisible = false;
    this.operationType = 'I';
};
export var LeDeviceAttribute = function LeDeviceAttribute() {
    _classCallCheck(this, LeDeviceAttribute);

    this.name = '';
    this.value = '';
};
export var BusinessAttr = function BusinessAttr() {
    _classCallCheck(this, BusinessAttr);

    this.name = '';
    this.detailDesc = '';
    this.desc = '';
    this.desc1 = '';
    this.desc2 = '';
    this.desc3 = '';
    this.desc4 = '';
    this.alias = '';
};
export var AttrNameList = function AttrNameList() {
    _classCallCheck(this, AttrNameList);

    this.name = '';
    this.valueType = '';
    this.defaultValue = '';
};
export var CmdPara = function CmdPara() {
    _classCallCheck(this, CmdPara);

    this.cmdName = '';
    this.attrNameList = [];
};
export var BaseInfo = function BaseInfo(ret) {
    _classCallCheck(this, BaseInfo);

    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    this.connection = (_b = (_a = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _a === void 0 ? void 0 : _a.connection) !== null && _b !== void 0 ? _b : 'UNCONNECT';
    this.deviceId = (_d = (_c = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _c === void 0 ? void 0 : _c.deviceId) !== null && _d !== void 0 ? _d : '';
    this.deviceType = (_f = (_e = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _e === void 0 ? void 0 : _e.deviceType) !== null && _f !== void 0 ? _f : '';
    this.model = (_h = (_g = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _g === void 0 ? void 0 : _g.model) !== null && _h !== void 0 ? _h : '';
    this.typeId = (_k = (_j = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _j === void 0 ? void 0 : _j.typeId) !== null && _k !== void 0 ? _k : '';
    this.onlineStateV2 = (_m = (_l = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _l === void 0 ? void 0 : _l.onlineStateV2) !== null && _m !== void 0 ? _m : '';
    this.bleState = (_p = (_o = ret === null || ret === void 0 ? void 0 : ret.retData) === null || _o === void 0 ? void 0 : _o.bleState) !== null && _p !== void 0 ? _p : '';
};
export var Caution = function Caution() {
    _classCallCheck(this, Caution);
};
export var Command = function Command() {
    _classCallCheck(this, Command);
};